import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  CommonUtility,
  DataService, DateUtility,
  EmploymentPlan,
  EmploymentPlanSummary,
  ServerConstantsService, WpEtEnrollment,
  WpPerson,
  ClientInformation, Role, WpReferral, Task, MIN_CHAR_SEARCH_LENGTH,
  CaseNotes
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpClient } from '@angular/common/http';
import { EnrollmentSumary } from '../shared/model/EnrollmentSumary';
import { ProviderOffice } from '../shared/model/ProviderOffice';
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ProviderService } from '../provider-management/provider-management.service';
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import * as $ from 'jquery';
import { GridOptions } from "ag-grid/main";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-enrollment-detail',
  templateUrl: './enrollment-detail.component.html',
  styleUrls: ['./enrollment-detail.component.scss']
})
export class EnrollmentDetailComponent implements OnInit, CanComponentDeactivate {

  serverConstants: any;
  sharedData: any;
  refData: any;
  firstTime: Boolean = true;
  userActionNotificationsMap: any;

  employmentPlans: EmploymentPlan[];
  employmentPlan: EmploymentPlan;
  employmentPlanSummary: EmploymentPlanSummary;
  enrollmentSummary: EnrollmentSumary;
  enrollmentEndDt: any = null;
  context: any;
  tabToNextCell:any;

  empPlanStatusMap: any;
  empPlanStatusArray: any[];

  enrollmentList: WpEtEnrollment[] = [];
  wpPerson: WpPerson;
  referralId = '';
  wpPersonId = '';
  providersMap: any[];

  providerName: any;
  empPlanStatus: any;
  providerOffices: ProviderOffice[] = [];
  providerId;
  enrollment;
  selected:Boolean = false;
  isCurrentEnrollment:Boolean = false;
  empStatusCd = '';
  isEmpStatusDisabled: Boolean = false;
  isCaseClosure = 'N';
  closureReasonCd: any = null;
  closureReasonArray;
  isUniverse = false;
  isCaseClosedVisible: Boolean = false;
  isCaseClosedDisabled: Boolean = false;
  roles: Role[];

  isAuthorizedUser: Boolean = false;
  isReadOnlyUser: Boolean = false;
  isCaseClosed: Boolean = false;

  triggerReasons = ['CC', 'DO', 'NC', 'CN', 'LC'];

  enrollmentSummaryRequest: EnrollmentSumary;
  maxClosureDate: any;

  disablePrintCorrespondence = true;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('yes') yes: ElementRef;
  @ViewChild('no') no: ElementRef;
  @ViewChild('caseClosure') caseClosure: ElementRef;
  @ViewChild('closureRsn') closureRsn: ElementRef;
  @ViewChild('saveBtn') saveBtn: ElementRef;

  clientInfo: ClientInformation;


  // Elastic Search constiables

  elasticSuggestions = new BehaviorSubject<any>(null);
  suggestions: any = [];
  results: any = [];
  caseAssignmentFlag = false;


  MIN_CHAR_SEARCH_LENGTH = MIN_CHAR_SEARCH_LENGTH;
  selectCounty = false;
  countyId = 0;
  isChangeDetected: boolean;
  counties: any = null;
  countiesRT: any = null;

  isReActivateCase;
  reActivateReasonArray;
  reActivateReasonCd;
  serviceError:Boolean = false;

  loaderFocusAssProv: Boolean = false;

  gridOptions: GridOptions;
  gridApi:any;

  // US #14_01 | POIGAI
  assingedServiceCounty: any;
  serviceCountySuggestions: any = [];
  serviceCountySelected: Boolean = false;
  columnDefs: any;
  countyCds: any;
  loaderFocusAssCounty: Boolean = false;
  selectedServiceCountyId: number;
  prevServiceCountyName: any;
  prevProviderName: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
    private providerService: ProviderService,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('CLINF') === undefined) {
      this.router.navigate(['/task']);
    }
    this.gridOptions = <GridOptions>{};
  }

  getSuggestions(event) {
    this.selected = false;
    this.suggestions = [];
    this.elasticSuggestions.next(null);
    if (this.providerName !== undefined && this.providerName.length >= MIN_CHAR_SEARCH_LENGTH) {
      event.srcElement.blur();
      event.preventDefault();
      this.elasticSearch(this.providerName, this.elasticSuggestions);
      this.elasticSuggestions.subscribe((value) => {
        this.suggestions = [];
        if (value !== null && value.length > 0) {
          value.forEach(element => {
            this.suggestions.push(element);
          });

        } else {

        }
      });
    } else {
      this.suggestions = [];
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };


  autoCompleteResultKeydown(result, event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.srcElement.blur();
      event.preventDefault();
     this.autoCompleteResultClick(result);
     //this.loaderFocusAssProv = false;
    } else {
      return;
    }
  }

  autoCompleteResultClick(result) {
    this.selected = true;
    this.serviceError = false;
    this.providerName = result.name;
    this.providerId = result.providerId;
    this.suggestions = [];
    this.elasticSuggestions.next(null);

    // US # 14_01 - Commented as per Hannah discussion select county which is
    // marked in yellow will be replaced with Assigned Service County.
    // this.providerService.getcountyDetails(result.providerId).subscribe((data) => {
    //   this.counties = [];
    //   for (let i = 0; i < data.length; i++) {
    //     let name = '';
    //     const value = data[i].serviceCounty.toString();
    //     for (let j = 0; j < this.countiesRT.length; j++) {
    //       if (this.countiesRT[j].value === value) {
    //         name = this.countiesRT[j].name;
    //         break;
    //       }
    //     }
    //     this.counties.push({ value: value, name: name });
    //   }
    //   this.counties.sort(this.commonUtil.sortObjectsByStringProperty('name'));
    //   this.counties.unshift({ value: undefined, name: 'Pick an Option' });
    //   this.countyId = undefined;
    //   this.selectCounty = true;
    // });
  }

  elasticSearch(searchQuery, results) {
    this.elasticSuggestions.next(null);

    this.suggestions = [];
    this.http.post(this.serverConstants.SERVER_API_URL + '/service-provider/get-only-providers/', {text: searchQuery}).subscribe(
      (val) => {
        results.next(val);
      },
      response => {
        this.notificationService.error('Component Details', this.userActionNotificationsMap.ERROR);
        results.next(null);
      }
    );
  }

  ngOnInit() {
    this.caseAssignmentFlag = false;
    this.dataService.globalAccess = false;
    this.sharedData = this.dataService.getSharedDataObject();
    this.employmentPlanSummary = new EmploymentPlanSummary();
    this.employmentPlan = new EmploymentPlan();
    this.enrollmentSummary = new EnrollmentSumary();
    this.enrollmentSummary.etEnrollment = new WpEtEnrollment();
    this.referralId = this.sharedData.get('referralId');

    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.providersMap = this.sharedData.get('providers');
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
    this.providerId = this.sharedData.get('providerId');
    this.roles = this.sharedData.get('roles');

    
    console.log("selectedEnrollmentId : " + this.sharedData.get('selectedEnrollmentId'));
    console.log("selectedReferralId : " + this.sharedData.get('selectedReferralId'));

    if (this.sharedData.get('selectedEnrollmentId') !== null && this.sharedData.get('selectedEnrollmentId') !== undefined) {
      this.employmentPlanSummary.etEnrollmentId = Number(this.sharedData.get('selectedEnrollmentId'));
    }

    if (this.sharedData.get('selectedReferralId') !== null && this.sharedData.get('selectedReferralId') !== undefined) {
      this.referralId = this.sharedData.get('selectedReferralId');
    }

    if (this.sharedData.get('selectedEnrollmentEndDt') !== null && this.sharedData.get('selectedEnrollmentEndDt') !== undefined) {
      this.isCurrentEnrollment = false;
      //this.isCaseClosedVisible = false;
    } else {
      this.isCurrentEnrollment = true;
      //this.isCaseClosedVisible = true;
    }

    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadClientInfoFromAries(this.sharedData.get('personProvider').emciId) : this.loadClientInfoFromAnswer();
    this.loadProviderOffices();
    this.userAccess();
    this.parseRefTableData();
    // US #14_01 | POIGAI
    this.countyCds = this.data.getValueFromSharedDataMap('COUNTIES');
   
    console.log('this.employmentPlanSummary.etEnrollmentId  :' +this.employmentPlanSummary.etEnrollmentId );
    if (!this.isUniverse) {
      this.loadEtEnrollment();
    }

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  validDates() {
    const todayDate = new Date();
    this.maxClosureDate = {
      month: todayDate.getMonth() + 1,
      day: todayDate.getDate(),
      year: todayDate.getFullYear()
    };
  }

  userAccess() {
    this.isAuthorizedUser = false;

    for (const role of this.roles) {

      if (role.id === 5 || role.id === 4) {
        this.isAuthorizedUser = true;
      } else {
        this.isCaseClosedDisabled = true;
      }

      if (role.id === 4) {
        this.caseAssignmentFlag = true;
      }

    }
  }
  
  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }

    // We create a Date object for comparison against the filter date
    // const dateStr = (cellValue.split(" "))[0];
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  loadEnrollmentsList() {
    console.log('Loading all enrollments...');
    this.http.post<WpEtEnrollment[]>(this.serverConstants.COMMON_SERVER_API_URL + '/wp-et-enrollment/list', {
      'personId': Number(this.wpPersonId),
      'referralId': Number(this.referralId)
    }).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Enrollment Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data.length > 0) {
            this.enrollmentList = data;
          } else {
            this.enrollmentList = [];
          }
        }
      }, response => {
        this.notificationService.error('Enrollment Summary', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }

  loadEtEnrollment() {
    this.selected = true;
    this.http.post<EnrollmentSumary>(this.serverConstants.COMMON_SERVER_API_URL +
      '/wp-et-enrollment/get-et-enrollment-and-provider-name-by-personId', {
        'personId': Number(this.wpPersonId),
        'referralId': Number(this.referralId)
      }).subscribe(
        (data: EnrollmentSumary) => {
          if (data == null || data.hasOwnProperty('errorCode')) {
            this.notificationService.error('Enrollment', this.userActionNotificationsMap.ERROR);
          } else {
            this.enrollmentSummary = data;
            this.enrollmentSummary.etEnrollment.referredDt =
              this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.referredDt);
            if (this.enrollmentSummary.etEnrollment.assessmentDt != null
              && this.enrollmentSummary.etEnrollment.assessmentDt !== undefined) {
              this.enrollmentSummary.etEnrollment.assessmentDt =
                this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.assessmentDt);

            }
            if (this.enrollmentSummary.etEnrollment.enrollmentStartDt != null
              && this.enrollmentSummary.etEnrollment.enrollmentStartDt !== undefined) {
              this.enrollmentSummary.etEnrollment.enrollmentStartDt =
                this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.enrollmentStartDt);
            }

            this.providerName = this.convertCode(this.providersMap, this.enrollmentSummary.providerId);
            this.assingedServiceCounty = this.getCountyName(this.enrollmentSummary.countyId);
            console.log(this.assingedServiceCounty);
            this.closureReasonCd = this.enrollmentSummary.etEnrollment.closureReasonCd;

            if (this.enrollmentSummary.etEnrollment.enrollmentEndDt != null
              && this.enrollmentSummary.etEnrollment.enrollmentEndDt !== undefined) {
              this.enrollmentEndDt = this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.enrollmentEndDt);


              this.isCaseClosure = 'Y';
              this.isCaseClosed = true;

              if (this.triggerReasons.includes(this.closureReasonCd)) {
                this.disablePrintCorrespondence = false;
              }
            }

            if (this.enrollmentSummary.empStatusCd != null
              && this.enrollmentSummary.empStatusCd !== undefined) {
                this.empStatusCd = this.enrollmentSummary.empStatusCd.toString();
                console.log('this.empStatusCd ==== ' + this.empStatusCd);
              }
              
              this.roles = this.sharedData.get('roles');
              if(this.roles != undefined ){
                for( const role of this.roles){
                  if( role.id === 1 || role.id === 2 || role.id === 3 ){
                    this.isEmpStatusDisabled = true;
                    break;
                  }
                }               
              }
              
              console.log(" this.isEmpStatusDisabled ====== " + this.isEmpStatusDisabled);

          }
        },
        response => {
          this.notificationService.error('Enrollment', this.userActionNotificationsMap.ERROR);
        },
        () => {
          console.log('Loading emp plan:' + this.employmentPlanSummary.etEnrollmentId );
          this.loadEmploymentPlan();
        });
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  loadProviderOffices() {
    this.http.post<ProviderOffice[]>(this.serverConstants.SERVER_API_URL + '/providerOffice/provider', Number(this.providerId)).subscribe(
      (data: ProviderOffice[]) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Provider Office', this.userActionNotificationsMap.ERROR);
        } else {
          if (data != null) {
            this.providerOffices = data;
          }
        }
      },
      response => {
        this.notificationService.error('Provider Office', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  loadEmploymentPlan() {
    this.http.post<EmploymentPlanSummary>(this.serverConstants.SERVER_API_URL +
      '/employmentplan/load', this.employmentPlanSummary).subscribe(
        (data: EmploymentPlanSummary) => {
          if (data.hasOwnProperty('errorCode')) {
            this.notificationService.error('Employment Plan', this.userActionNotificationsMap.ERROR);
          } else {
            if (data != null) {
              this.employmentPlans = [];
              if (data.employmentPlan.length > 0) {
                this.validDates();
                this.employmentPlans = data.employmentPlan;
                //this.employmentPlans.sort((a, b) => new Date(b.estimatedCompletionDt).getTime()
                 // - new Date(a.estimatedCompletionDt).getTime());

                this.employmentPlan = this.employmentPlans[0];
                this.employmentPlan.empPlanStartDt = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStartDt);
                this.employmentPlan.empPlanStatusDt = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStatusDt);
                this.employmentPlan.estimatedCompletionDt =
                  this.dateUtility.convertDateFromServer(this.employmentPlan.estimatedCompletionDt);
                this.empPlanStatus = this.convertCode(this.empPlanStatusMap, this.employmentPlan.empPlanStatusCd);

                this.isCaseClosedVisible = true;
                for (const empPlan of this.employmentPlans) {
                  if (empPlan.empPlanStatusCd === 'OP') {
                    this.isCaseClosedVisible = false;
                  }
                }

              } else {
                this.isCaseClosedVisible = true;
                this.employmentPlans = [];

              }
            }
          }
        }, response => {
          this.notificationService.error('Employment Plan', this.userActionNotificationsMap.ERROR);
        }, () => {
        });
  }

  saveEnrollment() {
    if(this.selected !== true){
      this.serviceError = true;
    }
    else{
    this.enrollmentSummaryRequest = this.enrollmentSummary;
    if (this.caseAssignmentFlag
      && this.providerId !== null
      && this.providerId !== undefined
      && this.enrollmentSummary.providerId !== this.providerId) {
      this.enrollmentSummaryRequest.changeProvider = 'Y';
      this.prevProviderName = this.convertCode(this.providersMap, this.enrollmentSummary.providerId);
      this.enrollmentSummaryRequest.providerId = this.providerId;
    } else {
      this.enrollmentSummaryRequest.changeProvider = null;
    }

    if (this.caseAssignmentFlag
      && this.selectedServiceCountyId !== null
      && this.selectedServiceCountyId !== undefined
      && this.enrollmentSummary.countyId !== this.selectedServiceCountyId) {
      this.enrollmentSummaryRequest.changeCounty = 'Y';
      this.prevServiceCountyName = this.getCountyName(this.enrollmentSummaryRequest.countyId);
      this.enrollmentSummaryRequest.countyId = this.selectedServiceCountyId;
    } else {
      this.enrollmentSummaryRequest.changeCounty = null;
    }

    if (this.isCaseClosure === 'N') {
      this.enrollmentSummaryRequest.etEnrollment.enrollmentEndDt = null;
      this.enrollmentSummaryRequest.etEnrollment.closureReasonCd = null;
    } else {
      this.enrollmentSummaryRequest.etEnrollment.closureReasonCd = this.closureReasonCd;
      this.enrollmentSummaryRequest.etEnrollment.enrollmentEndDt = this.dateUtility.convertDateForServer(this.enrollmentEndDt);
    }

    if (this.isReActivateCase === 'Y') {
      this.enrollmentSummaryRequest.etEnrollment.enrollmentEndDt = null;
      this.enrollmentSummaryRequest.etEnrollment.closureReasonCd = null;
      this.enrollmentSummaryRequest.etEnrollment.reActivateReasonCd = this.reActivateReasonCd;
    }

    if (this.enrollmentSummaryRequest.etEnrollment.assessmentDt != null
      && this.enrollmentSummaryRequest.etEnrollment.assessmentDt !== undefined) {
      this.enrollmentSummaryRequest.etEnrollment.assessmentDt =
        this.dateUtility.convertDateForServer(this.enrollmentSummary.etEnrollment.assessmentDt);
    }
    if (this.enrollmentSummaryRequest.etEnrollment.enrollmentStartDt != null
      && this.enrollmentSummaryRequest.etEnrollment.enrollmentStartDt !== undefined) {
      this.enrollmentSummaryRequest.etEnrollment.enrollmentStartDt =
        this.dateUtility.convertDateForServer(this.enrollmentSummary.etEnrollment.enrollmentStartDt);
    }
    if (this.enrollmentSummaryRequest.etEnrollment.referredDt != null
      && this.enrollmentSummaryRequest.etEnrollment.referredDt !== undefined) {
      this.enrollmentSummaryRequest.etEnrollment.referredDt =
        this.dateUtility.convertDateForServer(this.enrollmentSummary.etEnrollment.referredDt);
    }
    this.enrollmentSummaryRequest.empStatusCd = this.empStatusCd;

    this.http.post<EnrollmentSumary>(this.serverConstants.COMMON_SERVER_API_URL +
      '/wp-et-enrollment/update-enrollment', this.enrollmentSummaryRequest).subscribe(
        (data: EnrollmentSumary) => {

          if (data.etEnrollment == null || data.hasOwnProperty('errorCode')) {
            this.notificationService.error('Enrollment', this.userActionNotificationsMap.ERROR);
            setTimeout(() => this.fileInput.nativeElement.focus(), 0);
            this.fileInput.nativeElement.click();

            this.enrollmentSummary.etEnrollment.referredDt =
              this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.referredDt);

            if (this.enrollmentSummary.etEnrollment.assessmentDt != null
              && this.enrollmentSummary.etEnrollment.assessmentDt !== undefined) {
              this.enrollmentSummary.etEnrollment.assessmentDt =
                this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.assessmentDt);

            }
            if (this.enrollmentSummary.etEnrollment.enrollmentStartDt != null
              && this.enrollmentSummary.etEnrollment.enrollmentStartDt !== undefined) {
              this.enrollmentSummary.etEnrollment.enrollmentStartDt =
                this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.enrollmentStartDt);
            }

          } else {
            this.createCaseNotes(this.enrollmentSummary); // CREATE CASE NOTES
            this.enrollmentSummary = null;
            this.enrollmentSummary = data;
            this.enrollmentSummary.etEnrollment.referredDt =
              this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.referredDt);
            if (this.enrollmentSummary.etEnrollment.assessmentDt != null
              && this.enrollmentSummary.etEnrollment.assessmentDt !== undefined) {
              this.enrollmentSummary.etEnrollment.assessmentDt =
                this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.assessmentDt);
            }
            if (this.enrollmentSummary.etEnrollment.enrollmentEndDt != null
              && this.enrollmentSummary.etEnrollment.enrollmentEndDt !== undefined) {


              this.dataService.makeAllPagesReadyIfCaseClosed();
              this.enrollmentEndDt = this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.enrollmentEndDt);

              this.isCaseClosed = true;
              this.isCaseClosure = 'Y';

              this.closureReasonCd = this.enrollmentSummary.etEnrollment.closureReasonCd;

              if (this.triggerReasons.includes(this.closureReasonCd)) {
                this.createCaseClosureTrigger();
              } else {
                this.disablePrintCorrespondence = true;
              }
              this.createClosedTask();
            } else {
              this.isCaseClosed = false;
              this.isCaseClosure = 'N';
              this.isReActivateCase = 'N';
              this.dataService.revertReadOnlyChanges();
              this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
            }

            if (this.enrollmentSummary.etEnrollment.enrollmentStartDt != null
              && this.enrollmentSummary.etEnrollment.enrollmentStartDt !== undefined) {
              this.enrollmentSummary.etEnrollment.enrollmentStartDt
                = this.dateUtility.convertDateFromServer(this.enrollmentSummary.etEnrollment.enrollmentStartDt);
            }
            this.notificationService.success('Case updated', this.userActionNotificationsMap.UPDATE);
            setTimeout(() => this.headerText.nativeElement.focus(), 0);
            this.headerText.nativeElement.click();
            if (this.triggerReasons.includes(this.closureReasonCd)) {
              this.disablePrintCorrespondence = false;
            }
          }
        },
        response => {
          this.notificationService.error('Enrollment', this.userActionNotificationsMap.ERROR);
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);
          this.fileInput.nativeElement.click();
        },
        () => {

        });
  }
}

  createTask() {
    const closeTask = new Task();
    closeTask.wpPerson = new WpPerson();
    closeTask.wpPerson.id = Number(this.wpPersonId);
    closeTask.wpReferral = new WpReferral();
    closeTask.wpReferral.id = Number(this.referralId);
    closeTask.assignedToInd = 'P';
    closeTask.programCd = 'FS';
    return closeTask;
  }

  createClosedTask() {
    const tasks = [];
    let closedTask;
    if (this.enrollmentSummary.etEnrollment.closureReasonCd === 'NC') { // Non Cooperation Sanction
      closedTask = this.createTask();
      closedTask.taskType = 'ND'; // Non Compliance Decision Task
      tasks.push(closedTask);
    } else if (this.enrollmentSummary.etEnrollment.closureReasonCd === 'CN') { // Client not longer eligible for SNAP Works
      closedTask = this.createTask();
      closedTask.taskType = 'CN'; // Client Not Longer RTW Task
      tasks.push(closedTask);
    } else if (this.enrollmentSummary.etEnrollment.closureReasonCd === 'CC') { // SNAP Case Closed
      closedTask = this.createTask();
      closedTask.taskType = 'CD'; // Client Dropped From SNAP Case Task
      tasks.push(closedTask);

      const closedTask2 = this.createTask();
      closedTask2.taskType = 'CC'; // Case Closure Task
      tasks.push(closedTask2);
    }

    if (tasks.length > 0) {
      this.closeTask(tasks);
    } else {
      return;
    }

  }

  formatDates(params) {
    if (!params.value) {
      return null;
    }

    // //const dateStr = (params.value.split(" "))[0];
    // const dateStr = (params.value.split(" "))[0];
    const dateParts = params.value.split('/');

    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

  closeTask(tasks) {
    this.http.post<Task>(this.serverConstants.SERVER_API_URL + '/taskManagement/closeTasks', tasks).subscribe(
      (val) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Task Closure', this.userActionNotificationsMap.ERROR);
        } else {

          this.notificationService.success('Task Closure', this.userActionNotificationsMap.UPDATE);

        }
      },
      response => {
        this.notificationService.error('Task Closure', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }


  createCaseClosureTrigger() {
    const caseClosureRequest = new CaseClosureRequest();
    if (this.clientInfo !== undefined) {

      caseClosureRequest.mailingAddrLine1 = this.clientInfo.MAILING_ADDR_LINE1;
      caseClosureRequest.mailingAddrLine2 = this.clientInfo.MAILING_ADDR_LINE2;
      caseClosureRequest.mailingAddrCity = this.clientInfo.MAILING_ADDR_CITY;
      caseClosureRequest.mailingAddrState = this.clientInfo.MAILING_ADDR_STATE;
      caseClosureRequest.mailingAddrZip = this.clientInfo.MAILING_ADDR_ZIP;

    }
    if (this.providerOffices.length > 0) {
      const office = this.providerOffices[0];

      caseClosureRequest.primaryAddrLine1 = office.primaryAddrLine1;
      caseClosureRequest.primaryAddrLine2 = office.primaryAddrLine2;
      caseClosureRequest.primaryCity = office.primaryCity;
      caseClosureRequest.primaryState = office.primaryState;
      caseClosureRequest.primaryZip5 = office.primaryZip5;
      caseClosureRequest.primaryZip4 = office.primaryZip4;
      caseClosureRequest.providerPhoneNumber = office.primaryPhoneNumber;
      caseClosureRequest.providerPhoneNumberExt = office.primaryPhoneNumberExt;


    }

    let wpPerson;
    if (this.sharedData.get('wpPerson') !== null && this.sharedData.get('wpPerson') !== undefined) {
      wpPerson = this.sharedData.get('wpPerson');
    }

    caseClosureRequest.clientName = wpPerson.firstName + ' ' + wpPerson.lastName;
    caseClosureRequest.caseNumber = wpPerson.budgetUnitId;
    caseClosureRequest.id = wpPerson.id;
    caseClosureRequest.coType = 'CC';
    caseClosureRequest.personId = Number(this.wpPersonId);
    caseClosureRequest.providerName = this.providerName;

    this.http.post<any>(this.serverConstants.CORRESPONDENCE_API_URL + '/correspondence/createTriggerCaseClose', caseClosureRequest)
      .subscribe(
        (res: any) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Correspondence', this.userActionNotificationsMap.ERROR);
          } else {
            if (res.id === this.enrollment.id) {
              this.notificationService.success('Correspondence',
                'Case Closure Notice is generated and can be accessed from the Correspondence page.');
              this.disablePrintCorrespondence = false;
            }
          }
        },
        (response) => {
          this.notificationService.error('Correspondence', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });

  }

  loadClientInfoFromAries(emciId){
    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/clientInfo/' + emciId + "/null").subscribe(
      (data: Array<Object>) => {
        console.log(' data =: ' + data);
        this.clientInfo = new ClientInformation();
        if (data !== null && data !== undefined && data.length > 0) {
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA');
          this.clientInfo.MAILING_ADDR_LINE1=address["addrLine1"];
          this.clientInfo.MAILING_ADDR_LINE2=address["addrLine2"];
          this.clientInfo.MAILING_ADDR_CITY=address["addrCity"];
          this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"];
          this.clientInfo.MAILING_ADDR_STATE=address["addrStateCd"];
          this.clientInfo.MAILING_ADDR_ZIP=address["addrZip5"];
        }
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA');
          //(this.clientInfo.RESIDENTIAL_COUNTY === null && address["addrCountyCd"] !== null) ? this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"] : this.clientInfo.RESIDENTIAL_COUNTY=this.clientInfo.RESIDENTIAL_COUNTY;
          //this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"];
          this.clientInfo.MAILING_ADDR_LINE1=address["addrLine1"];
          this.clientInfo.MAILING_ADDR_LINE2=address["addrLine2"];
          this.clientInfo.MAILING_ADDR_CITY=address["addrCity"];
          this.clientInfo.MAILING_ADDR_STATE=address["addrStateCd"];
          this.clientInfo.MAILING_ADDR_ZIP=address["addrZip5"];
        }
          this.clientInfo.CLIENTID = data[0]["indvId"];
          this.clientInfo.FIRST_NAME = data[0]["firstName"];
          this.clientInfo.LAST_NAME = data[0]["lastName"];
          this.clientInfo.MESSAGE_PHONE = data[0]["primaryPhnNum"];
          this.clientInfo.WORK_PHONE = data[0]["workPhnNum"];
          this.clientInfo.RESIDENTIAL_PHONE = data[0]["altPhnNum"];
          this.clientInfo.PRIMARY_LANGUAGE = data[0]["primaryLang"];
          this.clientInfo.EMCI_ID = data[0]["indvId"];
          if(data[0]["genderCd"] === 'M'){
            this.clientInfo.GENDER_CD = "Male";
          }
          else{
            this.clientInfo.GENDER_CD = "Female";
          }

        } else {
          // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
          // notification to be changed to red, and changed to the following verbiage: 'Case Closed. SNAP Case is closed.'
          this.notificationService.warn('Appointment', 'Client Summary Information not found in Eligibility System');
        }
      },
      response => {
        this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
      },
      () => {
        //this.notificationService.warn('Appointment', 'Client Summary Information not found in Eligibility System');
      });

  }

  loadClientInfoFromAnswer() {
    const ssnValue = this.sharedData.get('SSN_SEARCH');

    this.http.get<ClientInformation[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetDemographic/' + ssnValue).subscribe(
      (data: ClientInformation[]) => {
        if (data !== null && data !== undefined && data.length > 0) {
          this.clientInfo = data[0];
          if(this.clientInfo.MAILING_ADDR_LINE1 == ""){
            this.clientInfo.MAILING_ADDR_LINE1 = null;
          }

        } else {
          this.notificationService.warn('Enrollment Summary', 'Client Summary Information not found in Eligibility System');
        }
      },
      response => {
        this.notificationService.error('Enrollment Summary', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  parseRefTableData() {
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(
      this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.empPlanStatusArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_PLAN_STATUS');
    this.closureReasonArray = this.data.getValueFromSharedDataMap('CASE_CLOSURE_REASON');
    this.reActivateReasonArray = this.data.getValueFromSharedDataMap('CASE_RE_ACTIVATION_REASON');
    this.empPlanStatusMap = this.commonUtil.createMapFromList(this.empPlanStatusArray);
    this.countiesRT = this.data.getValueFromSharedDataMap('COUNTIES');
  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  onAssignProviderChange(event) {
    this.loaderFocusAssProv = true;
    event.srcElement.blur();
    event.preventDefault();
  }

  assignProviderNoFocus(e) {
    if (e.keyCode === 9 && !e.shiftKey) {
      this.loaderFocusAssProv = false;
    }
  }

  assignedProvider(event) {
    if ( this.caseAssignmentFlag ) {
      this.loaderFocusAssProv = true;
    }
  }

  reset() {
    if (!this.isUniverse) {
      this.loadEtEnrollment();
    }
  }

  focusReferralDt(e: KeyboardEvent) {
    if (e.keyCode === 9) {
      setTimeout(() => this.fileInput.nativeElement.focus(), 0);
      // this.fileInput.nativeElement.click();
    }
  }

  focusYes(e: KeyboardEvent) {
    if (e.keyCode === 9) {
      setTimeout(() => this.yes.nativeElement.focus(), 0);
    }
  }

  focusNo(e: KeyboardEvent) {
    if (e.keyCode === 9) {
      setTimeout(() => this.no.nativeElement.focus(), 0);
    }
  }

  focusClosureDt(e: KeyboardEvent) {
    if (e.keyCode === 9) {
      setTimeout(() => this.caseClosure.nativeElement.focus(), 0);
      this.caseClosure.nativeElement.click();
    }
  }

  focusClosureRsn(e: KeyboardEvent) {
    if (e.keyCode === 9) {
      setTimeout(() => this.closureRsn.nativeElement.focus(), 0);
      this.closureRsn.nativeElement.click();
    }
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  assignedProviderFocus(event) {
    event.preventDefault();
    this.loaderFocusAssProv = true;
  }

  focusHeaderFromSave(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      if (this.disablePrintCorrespondence) {
        setTimeout(() => this.headerText.nativeElement.focus(), 0);
        this.headerText.nativeElement.click();
      }
    }
  }

  printCorrespondence() {
    this.router.navigate(['task/correspondence']);
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  onAssignServiceCountyChange(event) {
    this.loaderFocusAssCounty = true;
    event.srcElement.blur();
    event.preventDefault();
  }

  assignedServiceCountyFocus(event) {
    event.preventDefault();
    this.loaderFocusAssCounty = true;
  }

  autoCompleteAssingedServiceCountyKeydown(county, event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.srcElement.blur();
      event.preventDefault();
     this.autoCompleteResultClick(county);
    } else {
      return;
    }
  }

  autoCompleteAssingedServiceCountyClick(county) {
    // this.serviceError = false;
    this.assingedServiceCounty = county.name;
    this.selectedServiceCountyId = Number(county.value);
    this.serviceCountySuggestions = [];

  }

  getCountyName(countyId) {
    const countyDetails = this.countyCds.filter((county: any) =>
      county.value !== undefined
        && county.value == countyId
      );
    if (countyDetails !== undefined && countyDetails.length > 0) {
      console.log(countyDetails[0].name);
      return countyDetails[0].name;
    }
  }

  getServiceCountySuggestions(event) {
    // this.selected = false;
    this.serviceCountySuggestions = [];
    console.log(this.countyCds);
    if (this.assingedServiceCounty !== undefined && this.assingedServiceCounty.length >= MIN_CHAR_SEARCH_LENGTH) {
      event.srcElement.blur();
      event.preventDefault();

      const startsWithCounty = this.countyCds.filter((county: any) =>
          county.value !== undefined
          && this.enrollmentSummary.countyId != county.value
          && county.name
          .toUpperCase()
          .startsWith(this.assingedServiceCounty.toUpperCase())
      );
      this.serviceCountySuggestions = startsWithCounty;
      $('input.countySearch').focus();
    }
  }

  createCaseNotes(enrollmentSummary: EnrollmentSumary) {

    const YES = 'Y';
    if ( (enrollmentSummary.changeProvider  == null || enrollmentSummary.changeProvider === undefined)
        && (enrollmentSummary.changeCounty === null || enrollmentSummary.changeCounty === undefined)) {
          return;
    }

    const SERVICE_COUNTY_TXT: String = 'This client switched Service Counties from ';
    const PROVIDERS_TXT: String = 'This client switched Providers from ';
    const PROVIDERS_ALSO_TXT: String = ' and also switched Providers from ';
    const SYSTEM_GENREATED_TXT: String = ' This is a system-generated case note.';
    const COMMA: String = ',';
    const SPACE = ' ';
    const TO: String = ' to ';
    let caseNotes: String = '';
    const today = new Date();
    const date: String = this.dateUtility.getMonthName(today.getMonth()) + ' '
      + today.getDate() + COMMA + ' ' + today.getFullYear() + '.';
    const newProviderName = this.convertCode(this.providersMap, this.enrollmentSummary.providerId);
    const newServiceCounty = this.getCountyName(this.enrollmentSummary.countyId);

    if (enrollmentSummary.changeProvider === YES
          && enrollmentSummary.changeCounty === YES) {
            caseNotes = SERVICE_COUNTY_TXT + this.prevServiceCountyName + TO + newServiceCounty + COMMA
              + PROVIDERS_ALSO_TXT + this.prevProviderName + TO + newProviderName + SPACE
              + date + SYSTEM_GENREATED_TXT;
    } else if (enrollmentSummary.changeProvider === YES) {
      caseNotes = PROVIDERS_TXT + this.prevProviderName + TO + newProviderName + SPACE
      + date + SYSTEM_GENREATED_TXT;
    } else if (enrollmentSummary.changeCounty === YES) {
      caseNotes = SERVICE_COUNTY_TXT + this.prevServiceCountyName + TO + newServiceCounty + SPACE
      + date + SYSTEM_GENREATED_TXT;
    }
    this.saveCaseNote(caseNotes);

  }

  saveCaseNote(notes: any) {

    let caseNotes = new CaseNotes();
    caseNotes.createdDt = new Date();
    caseNotes.createdDt = this.dateUtility.convertObjectDateForServer(new Date());
    caseNotes.notes = notes;
    caseNotes.personId = Number(this.wpPersonId);
    caseNotes.typeCd = 'OT'; // OTHER TYPE
    const errMsg = 'Record not saved: Please review or contact Help Desk.';
    this.http.post<CaseNotes>(this.serverConstants.SERVER_API_URL + '/casenotes/save', caseNotes)
      .subscribe(
        (res: CaseNotes) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error(errMsg, this.userActionNotificationsMap.ERROR);
          } else {
            caseNotes = res;
            if (caseNotes.id !== undefined || caseNotes.id != null) {
              this.notificationService.success('Successfully saved', this.userActionNotificationsMap.UPDATE);
            }
          }
        },
        (response) => {
          this.notificationService.error(errMsg, this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }
}

class CaseClosureRequest {
  constructor(
    public id?: number,
    public personId?: number,
    public coType?: string,
    public clientName?: string,
    public caseNumber?: string,
    public providerName?: string,
    public providerPhoneNumber?: string,
    public providerPhoneNumberExt?: string,
    public primaryAddrLine1?: string,
    public primaryAddrLine2?: string,
    public primaryCity?: string,
    public primaryState?: string,
    public primaryZip5?: string,
    public primaryZip4?: string,
    public mailingAddrLine1?: string,
    public mailingAddrLine2?: string,
    public mailingAddrCity?: string,
    public mailingAddrState?: string,
    public mailingAddrZip?: string
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/enrollment-detail/enrollment-detail.component.ts